<template>
  <div id="result">
    <div class="success-icon-wrapper">
      <img :src="successImage" alt="" />
    </div>
    <div class="text1" v-if="$route.query.type == '2'">恭喜您注册成功已获得360天基础版免费使用权</div>
    <div class="text1" v-else>恭喜您注册成功</div>
    <div class="box1" v-if="$route.query.type == '3'">
      <span class="text8">已获得</span>
      <span class="text9">30天旗舰版功能使用权</span>
    </div>
    <!-- <div class="text2">请重新打开软件登陆即可使用</div> -->
    <div class="box2">
      <!-- <div class="box3">
        <div class="text3">广联达斑马进度计划软件<span class="text41">全套学习视频</span>送给你</div>
        <div class="text4">免费听案例，学操作，考取技能鉴定证书</div>
      </div> -->
      <!-- <div class="button1" @click="skip"><img style="margin-right: 5px;height: 16px" src="@/assets/images/video.png"/>点此观看学习视频</div> -->
      <!-- <div class="button1" @click="skip"><img style="margin-right: 5px;height: 16px" src="@/assets/images/video.png"/>登录</div> -->
      <a-space size="large">
        <a-button size="large" type="primary" @click="skip"><img style="margin-right: 5px;height: 16px" src="@/assets/images/video.png"/>点此观看学习视频</a-button>
        <a-button type="primary" size="large" :loading="iconLoading"  icon="login" @click="loginHandle">
          {{ iconLoading ? `倒计时 ${count} 秒去登录` : '点此前往登录页面' }}

        </a-button>
      </a-space>
    </div>
    <div class="box7">
      <img src="@/assets/images/qrcode360.png" alt="" v-if="$route.query.type == '2'">
      <img src="@/assets/images/qrcode90.png" alt="" v-if="$route.query.type == '3'">
      <span class="text7">扫码添加官方答疑群</span>
    </div>
    <!-- <footer>
      <a-button size="large" type="primary" @click="windowClose">关闭</a-button>
    </footer> -->
  </div>
</template>

<script>
import successImage from "@/assets/images/success.png";
import UserEnterpriseApi from "@/api/userEnterpriseApi.js";
// import maiFn from "@/utils/maidian";
export default {
  data() {
    return {
      successImage,
      infomation: "恭喜您已注册成功",
      text: "使用权，软件中内置有学习视频，祝您使用愉快",
      count: 5,
      iconLoading: true,
      timer: null
    };
  },
  mounted() {
    const { sgyToken, globalId, version, source } = UserEnterpriseApi;
    // maiFn(sgyToken, globalId, version, "show", this, "结果页展示", source);
    this.fiveGo()
  },
  methods: {
    fiveGo() {
      const TIME_COUNT = 5
      if(!this.timer){
        this.count = TIME_COUNT
        this.iconLoading = true
        this.timer = setInterval(()=>{
        if(this.count > 0 && this.count <= TIME_COUNT){
          this.count--
        } else {
          this.iconLoading = false
          clearInterval(this.timer)
          this.timer = null
        }
		  }, 1000)
		  }
    },
    loginHandle() {
      try {
        window.top.postMessage({ type: 'login', source: 'userInfo' }, '*')
      } catch (error) {
        console.warn(error)
      }
    },
    windowClose() {
      window.location.href = "about:blank";
      window.close();
    },

    /**
     * @Description: 跳转
     * @param {*}
     * @Date: 2022-04-27 17:38:45
     */
    skip() {
      // window.location.href = 'https://b.zpert.com/upload/client_home/buy.html'
      window.open(
        // "https://zhibo.glodon.com/live/watch/m2p4b1bl",
        "https://qr32.cn/EBpZyH",
        "_blank"
      );
    },
    /**
     * @Description: 跳转
     * @param {*}
     * @Date: 2022-04-27 17:38:45
     */
    skipUpgrade() {
      window.open(
        "https://shop.glodon.com/goodsDetail?skuId=1518054547817848834&goodsId=1517411275490340866",
        "_blank"
      );
    },
    /**
     * @Description: 跳转
     * @param {*}
     * @Date: 2022-04-27 17:38:45
     */
    skipBasic() {
      window.open(
        "https://shop.glodon.com/goodsDetail?skuId=1518054547998203906&goodsId=1517411275490340866",
        "_blank"
      );
    },
  },
};
</script>

<style scoped lang="scss">
#result {
  padding-top: 56px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .success-icon-wrapper {
    width: 234px;
    height: 139.87px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .text1 {
    height: 28px;
    font-size: 28px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    line-height: 48px;
    color: #3C5055;
    margin-top: 27px;
  }
  .text2 {
    height: 14px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 24px;
    color: #838AA0;
    opacity: 0.77;
    margin-top: 14px;
  }
  .box1 {
    margin-top: 16px;
    .text8 {
      font-size: 21px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #3C5055;
    }
    .text9 {
      font-size: 21px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #438AFE;
    }
  }
  .box2 {
    margin-top: 38px;
    display: flex;
    .box3 {
      margin-right: 11px;
      .text3 {
        font-size: 21px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #3C5055;
        line-height: 42px;
        .text41 {
          color: #F47241;
        }
      }
      .text4 {
        font-size: 21px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #3C5055;
        line-height: 42px;
      }
    }
    .button1 {
      margin: 20px auto;
      width: 197px;
      height: 45px;
      background: rgba(67, 138, 254);
      box-shadow: 0px 13px 18px rgba(20, 143, 233, 0.23);
      opacity: 1;
      border-radius: 50px;
      line-height: 45px;
      text-align: center;
      color: #FFFFFF;
      cursor: pointer;
      margin-left: 20px;
    }
  }
  .box7 {
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    width: 130px;
    .text7 {
      margin-top: 10px;
      font-size: 13px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #838AA0;
    }
  }
  .close {
    background-color: #438afe;
    margin-top: 53px;
    width: 154px;
    height: 46px;
    border-radius: 29px;
    line-height: 46px;
    text-align: center;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #fff;
    cursor: pointer;
  }

  footer {
    margin-top: 54px;
  }
}
</style>
